<mat-card style="border-radius: 0">
    <div>
        <div style="overflow: hidden; padding-bottom: 5px">
            <div class="card-info">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="display: flex; justify-content: space-between">
                    <div
                        class="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                        style="position: relative"
                        [ngStyle]="{ height: imInAccountManegement ? '' : '620px' }"
                    >
                        <div class="titleTabContent" style="text-align: center !important" *ngIf="imInAccountManegement">
                            <label translate>M_PERS_DATA</label>
                        </div>
                        <mat-card-content style="margin-bottom: 0">
                            <form class="form">
                                <mat-form-field
                                    appearance="outline"
                                    class="width-100"
                                    [ngClass]="imInAccountManegement === false ? 'fs-12' : ''"
                                >
                                    <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_1</mat-label>
                                    <input
                                        matInput
                                        (ngModelChange)="isChanged($event, 'AccountName')"
                                        [formControl]="accountnameControl"
                                        [readonly]="true"
                                        #accountKeyInput
                                        lowerCase
                                        [disabled]="true"
                                    />
                                    <mat-error *ngIf="accountnameControl.invalid">{{ getErrorMessage() }} </mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline" [ngClass]="imInAccountManegement === false ? 'fs-12' : ''">
                                    <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_2</mat-label>
                                    <input
                                        matInput
                                        (ngModelChange)="isChanged($event, 'FullName')"
                                        [formControl]="fullnameControl"
                                        required
                                        [readonly]="model.CASUser && model.CASUser?.length > 0"
                                    />
                                    <mat-error *ngIf="fullnameControl.invalid">{{ getFullNameErrorMessage() }} </mat-error>
                                </mat-form-field>
                                <mat-form-field appearance="outline" [ngClass]="imInAccountManegement === false ? 'fs-12' : ''">
                                    <mat-label>Email</mat-label>
                                    <input
                                        matInput
                                        (ngModelChange)="isChanged($event, 'Email')"
                                        [formControl]="emailControl"
                                        pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                        required
                                        [readonly]="model.CASUser && model.CASUser?.length > 0"
                                    />
                                    <mat-error *ngIf="emailControl.invalid">{{ getEmailErrorMessage() }} </mat-error>
                                </mat-form-field>
                                <mat-form-field
                                    appearance="outline"
                                    [ngClass]="imInAccountManegement === false ? 'fs-12' : ''"
                                    *ngIf="isDevOpsOrHigher"
                                >
                                    <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_5</mat-label>
                                    <input
                                        matInput
                                        [(ngModel)]="model.ParentAccount"
                                        name="ParentAccount"
                                        [disabled]="true"
                                        #parentAccountKeyInput
                                        lowerCase
                                        [readonly]="model.CASUser && model.CASUser?.length > 0"
                                    />
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    [ngClass]="imInAccountManegement === false ? 'fs-12' : ''"
                                    *ngIf="isDevOpsOrHigher"
                                >
                                    <mat-label>Mobile Phone Prefix</mat-label>
                                    <input
                                        matInput
                                        (ngModelChange)="isChanged($event, 'MobilePhonePrefix')"
                                        [(ngModel)]="model.MobilePhonePrefix"
                                        name="MobilePhonePrefix"
                                        [readonly]="model.CASUser?.lenght != 0"
                                    />
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    [ngClass]="imInAccountManegement === false ? 'fs-12' : ''"
                                    *ngIf="isDevOpsOrHigher"
                                >
                                    <mat-label>Mobile Phone Nr</mat-label>
                                    <input
                                        matInput
                                        (ngModelChange)="isChanged($event, 'MobilePhoneNr')"
                                        [(ngModel)]="model.MobilePhoneNr"
                                        name="MobilePhoneNr"
                                        [readonly]="model.CASUser?.lenght != 0"
                                    />
                                </mat-form-field>

                                <mat-form-field appearance="outline" [ngClass]="imInAccountManegement === false ? 'fs-12' : ''">
                                    <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_6</mat-label>
                                    <input
                                        matInput
                                        (ngModelChange)="isChanged($event, 'Notes')"
                                        [(ngModel)]="model.Notes"
                                        name="Notes"
                                        [readonly]="model.CASUser && model.CASUser?.length > 0"
                                    />
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    [ngClass]="imInAccountManegement === false ? 'fs-12' : ''"
                                    *ngIf="isDevOpsOrHigher"
                                >
                                    <mat-label translate>Private notes</mat-label>
                                    <textarea
                                        matInput
                                        (ngModelChange)="isChanged($event, 'PrivateNotes')"
                                        [(ngModel)]="model.PrivateNotes"
                                        name="PrivateNotes"
                                        [readonly]="model.CASUser?.lenght != 0"
                                    ></textarea>
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    [ngClass]="imInAccountManegement === false ? 'fs-12' : ''"
                                    *ngIf="isDevOpsOrHigher"
                                >
                                    <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_10</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        [(ngModel)]="model.LoginFailedCount"
                                        name="LoginFailedCount"
                                        [disabled]="true"
                                        [readonly]="model.CASUser?.lenght != 0"
                                    />
                                </mat-form-field>
                                <!-- <mat-form-field appearance="outline" [ngClass]="imInAccountManegement === false ? 'fs-12' : ''">
                                <mat-label translate>Nickname</mat-label>
                                <input matInput (ngModelChange)="isChanged($event, 'NickName')" [formControl]="nicknameControl" />
                            </mat-form-field>
                            <p class="color" *ngIf="errorNickName" translate>EDIT_ACCOUNTS.ERROR_NICKNAME</p> -->
                            </form>

                            <div class="bottom-button" *ngIf="!imInAccountManegement">
                                <button mat-flat-button color="primary" (click)="closeDrawer()">
                                    <span translate>M_CLOSE</span>
                                </button>
                            </div>
                        </mat-card-content>
                    </div>

                    <div
                        class="col-xs-12 col-sm-12 col-md-6 col-lg-6"
                        style="position: relative"
                        [ngStyle]="{ height: imInAccountManegement ? '' : '620px' }"
                    >
                        <div class="titleTabContent" style="text-align: center !important" *ngIf="imInAccountManegement">
                            <label translate>L_APP_CONFIGURATION</label>
                        </div>
                        <mat-card-content style="margin-bottom: 0">
                            <form class="form">
                                <mat-form-field appearance="outline" [ngClass]="imInAccountManegement === false ? 'fs-12' : ''">
                                    <mat-label translate>USER_FORM.COUNTRY</mat-label>
                                    <mat-select
                                        name="RegionalSettings"
                                        (ngModelChange)="isChanged($event, 'RegionalSettings')"
                                        [(ngModel)]="selectedRs"
                                        (value)="(selectedRs)"
                                        (selectionChange)="selectedRsChange($event)"
                                        [disabled]="model.CASUser && model.CASUser?.length > 0"
                                    >
                                        <mat-option *ngFor="let rs of regionalSettings" [value]="rs">
                                            {{ rs.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field appearance="outline" [ngClass]="imInAccountManegement === false ? 'fs-12' : ''">
                                    <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_4</mat-label>
                                    <mat-select
                                        name="Language"
                                        (ngModelChange)="isChanged($event, 'Language')"
                                        [(ngModel)]="selectedLanguage"
                                        (value)="(selectedLanguage)"
                                        (selectionChange)="selectedLanguageChange($event)"
                                        [disabled]="model.CASUser && model.CASUser?.length > 0"
                                    >
                                        <mat-option *ngFor="let l of languages" [value]="l">
                                            {{ l.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    [ngClass]="imInAccountManegement === false ? 'fs-12' : ''"
                                    *ngIf="isDevOpsOrHigher"
                                >
                                    <mat-label translate>Creation date</mat-label>
                                    <input
                                        #pref
                                        matInput
                                        [matDatepicker]="pdpc"
                                        [(ngModel)]="model.CreationDate"
                                        readonly="true"
                                        name="CreationDate"
                                    />
                                    <mat-datepicker #pdpc [disabled]="model.CASUser && model.CASUser?.length > 0"> </mat-datepicker>
                                </mat-form-field>

                                <mat-form-field appearance="outline" [ngClass]="imInAccountManegement === false ? 'fs-12' : ''">
                                    <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_11</mat-label>
                                    <input
                                        matInput
                                        [min]="minDate"
                                        [matDatepicker]="eD"
                                        (ngModelChange)="eDateValueChange(eD)"
                                        [(ngModel)]="model.ExpirationDate"
                                        name="ExpirationDate"
                                        readonly="true"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="eD"></mat-datepicker-toggle>
                                    <mat-datepicker
                                        #eD
                                        disabled="false"
                                        [disabled]="model.CASUser && model.CASUser?.length > 0"
                                    ></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field appearance="outline" [ngClass]="imInAccountManegement === false ? 'fs-12' : ''">
                                    <mat-label translate>EDIT_ACCOUNTS.IPT_FLD_8</mat-label>
                                    <input
                                        matInput
                                        [min]="minDate"
                                        [matDatepicker]="pED"
                                        (ngModelChange)="pDateValueChange(pED)"
                                        [(ngModel)]="model.PasswordExpirationDate"
                                        name="PasswordExpirationDate"
                                        readonly="true"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="pED"></mat-datepicker-toggle>
                                    <mat-datepicker #pED [disabled]="model.CASUser && model.CASUser?.length > 0"></mat-datepicker>
                                </mat-form-field>

                                <mat-form-field
                                    appearance="outline"
                                    [ngClass]="imInAccountManegement === false ? 'fs-12' : ''"
                                    *ngIf="isDevOpsOrHigher"
                                >
                                    <mat-label translate>Password duration in days</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        (ngModelChange)="isChanged($event, 'PasswordDuration')"
                                        [(ngModel)]="model.PasswordDuration"
                                        name="PasswordDuration"
                                        [readonly]="model.CASUser && model.CASUser?.length > 0"
                                    />
                                </mat-form-field>
                            </form>

                            <div class="mt10">
                                <div *ngIf="imInAccountManegement; else imNot">
                                    <mat-card-footer style="margin: 0; display: flex">
                                        <div style="display: flex; flex-direction: column; align-items: flex-start">
                                            <mat-checkbox
                                                (ngModelChange)="isChanged($event, 'Disabled')"
                                                [(ngModel)]="model.Disabled"
                                                name="Disabled"
                                                [disabled]="model.CASUser && model.CASUser?.length > 0"
                                                ><span translate>DISABLED</span>
                                            </mat-checkbox>
                                            <mat-checkbox
                                                [(ngModel)]="model.Confirmed"
                                                name="Confirmed"
                                                *ngIf="isDevOpsOrHigher"
                                                [disabled]="model.CASUser && model.CASUser?.length > 0"
                                            >
                                                <span translate>L_ACC_CONFIRMED</span>
                                            </mat-checkbox>
                                            <mat-checkbox
                                                (ngModelChange)="isChanged($event, 'Locked')"
                                                [(ngModel)]="model.Locked"
                                                name="Locked"
                                                (change)="changeLock()"
                                                [disabled]="model.CASUser && model.CASUser?.length > 0"
                                            >
                                                <span translate>L_ACC_LOCKED</span>
                                            </mat-checkbox>
                                            <mat-checkbox
                                                [disabled]="model.CannotChangePassword || (model.CASUser && model.CASUser?.length > 0)"
                                                (ngModelChange)="isChanged($event, 'MustChangePassword')"
                                                [(ngModel)]="model.MustChangePassword"
                                                name="MustChangePassword"
                                            >
                                                <span translate>L_ACC_MUSTCNGPWD</span>
                                            </mat-checkbox>
                                            <mat-checkbox
                                                *ngIf="isDevOpsOrHigher"
                                                (ngModelChange)="isChanged($event, 'PasswordNeverExpires')"
                                                [(ngModel)]="model.PasswordNeverExpires"
                                                name="PasswordNeverExpires"
                                                [disabled]="model.CASUser && model.CASUser?.length > 0"
                                            >
                                                <span translate>L_ACC_PWDNEVREXP</span>
                                            </mat-checkbox>
                                            <mat-checkbox
                                                *ngIf="isDevOpsOrHigher"
                                                [disabled]="model.MustChangePassword"
                                                (ngModelChange)="isChanged($event, 'CannotChangePassword')"
                                                [(ngModel)]="model.CannotChangePassword"
                                                name="CannotChangePassword"
                                                [disabled]="model.CASUser && model.CASUser?.length > 0"
                                            >
                                                <span translate>L_ACC_CNTCHNGPWD</span>
                                            </mat-checkbox>
                                        </div>
                                        <!-- <div style="display: flex;flex-direction: column;">
                                            <mat-checkbox [disabled]="model.CannotChangePassword" (ngModelChange)="isChanged($event, 'MustChangePassword')" [(ngModel)]="model.MustChangePassword" name="MustChangePassword">
                                                <span translate>L_ACC_MUSTCNGPWD</span>
                                            </mat-checkbox>
                                            <mat-checkbox (ngModelChange)="isChanged($event, 'PasswordNeverExpires')" [(ngModel)]="model.PasswordNeverExpires" name="PasswordNeverExpires">
                                                <span translate>L_ACC_PWDNEVREXP</span>
                                            </mat-checkbox>
                                            <mat-checkbox [disabled]="model.MustChangePassword" (ngModelChange)="isChanged($event, 'CannotChangePassword')" [(ngModel)]="model.CannotChangePassword" name="CannotChangePassword">
                                                <span translate>L_ACC_CNTCHNGPWD</span>
                                            </mat-checkbox>
                                        </div> -->
                                    </mat-card-footer>
                                </div>
                                <ng-template #imNot>
                                    <mat-card-footer style="margin: 0; font-size: 12px">
                                        <div style="display: flex; flex-direction: column; align-items: flex-start">
                                            model.CASUser{{ model.CASUser }}
                                            <mat-checkbox
                                                (ngModelChange)="isChanged($event, 'Disabled')"
                                                [(ngModel)]="model.Disabled"
                                                [disabled]="model.CASUser && model.CASUser?.length > 0"
                                                name="Disabled"
                                                ><span translate>DISABLED</span>
                                            </mat-checkbox>
                                            <mat-checkbox
                                                [disabled]="true"
                                                [(ngModel)]="model.Confirmed"
                                                [disabled]="model.CASUser && model.CASUser?.length > 0"
                                                name="Confirmed"
                                                *ngIf="isDevOpsOrHigher"
                                            >
                                                <span translate>L_ACC_CONFIRMED</span>
                                            </mat-checkbox>
                                            <mat-checkbox
                                                (ngModelChange)="isChanged($event, 'Locked')"
                                                [(ngModel)]="model.Locked"
                                                [disabled]="model.CASUser && model.CASUser?.length > 0"
                                                name="Locked"
                                                (change)="changeLock()"
                                            >
                                                <span translate>L_ACC_LOCKED</span>
                                            </mat-checkbox>
                                            <mat-checkbox
                                                [disabled]="(model.CASUser && model.CASUser?.length > 0) || model.CannotChangePassword"
                                                (ngModelChange)="isChanged($event, 'MustChangePassword')"
                                                [(ngModel)]="model.MustChangePassword"
                                                [readonly]="model.CASUser && model.CASUser?.length > 0"
                                                name="MustChangePassword"
                                            >
                                                <span translate>L_ACC_MUSTCNGPWD</span>
                                            </mat-checkbox>
                                            <!-- <mat-checkbox (ngModelChange)="isChanged($event, 'PasswordNeverExpires')" [(ngModel)]="model.PasswordNeverExpires" name="PasswordNeverExpires">
                                                <span translate>L_ACC_PWDNEVREXP</span>
                                            </mat-checkbox>
                                            <mat-checkbox [disabled]="model.MustChangePassword" (ngModelChange)="isChanged($event, 'CannotChangePassword')" [(ngModel)]="model.CannotChangePassword" name="CannotChangePassword">
                                                <span translate>L_ACC_CNTCHNGPWD</span>
                                            </mat-checkbox> -->
                                        </div>
                                    </mat-card-footer>
                                </ng-template>
                            </div>

                            <div class="button-alignment bottom-button" style="right: 0">
                                <button
                                    mat-flat-button
                                    color="primary"
                                    (click)="cancel()"
                                    [disabled]="!saving"
                                    class="left"
                                    [ngStyle]="{ width: imInAccountManegement ? '100px' : '93px' }"
                                >
                                    <span translate>B_CANCEL</span>
                                </button>
                                <button
                                    mat-flat-button
                                    (click)="saveAccount()"
                                    color="primary"
                                    [disabled]="!saving"
                                    [ngStyle]="{ width: imInAccountManegement ? '100px' : '93px' }"
                                >
                                    <span translate>B_SAVE</span>
                                </button>
                            </div>
                        </mat-card-content>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-card>
